import { InputForSignatureIndication } from '.';
import React, { useRef, useState } from 'react';
import SignaturePad from 'react-signature-canvas';
import { AlertImage } from '../../../../assets/Images';
import moment from 'moment';
import { toast } from 'material-react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginPageStyles } from '../../../../styles';
import { fetchDeliveryOverviewData } from '../../../../redux/features/Delivery';
import { setUserStatus, destroyUser } from '../../../../redux/features/User';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableHead,
  TableRow,
  styled,
  Typography,
} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import {
  setEnroutedPractices,
  setOrderCollectedTime,
  collectPracticeOrders,
  setCheckInId,
} from '../../../../redux/features/Practice';
import {
  LogisticSignatureInput,
  Toast as CustomToast,
} from '../../../../Components';
import { useLiveFeed } from '../../../../hooks';
import { isMalaysian } from '../../../../utils';

// Table Configuration
const cleanOrders = (data) => {
  let filteredOrders = data.map((item, idx) => {
    return {
      id: idx + 1,
      ...item,
    };
  });
  return filteredOrders;
};

// Defining Custom Styles

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#054E8B',
    color: theme.palette.common.white,
    fontFamily: 'Mukta',
    fontWeight: '700',
    fontSize: '15px',
    lineHeight: '20px',
    padding: '8px 16px',
    borderLeft: '1px solid #054E8B',
    letterSpacing: '0.005em',
  },
}));

const tableCellStyle = {
  fontSize: '15px',
  lineHeight: '19px',
  fontFamily: 'Mulish',
  padding: '8px 16px',
};

const btnTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          '&.Mui-disabled': {
            opacity: 0.7,
          },
        },
      },
    },
  },
});

const nextbuttonStyle = {
  fontFamily: 'Mukta',
  backgroundColor: '#054E8B',
  textTransform: 'capitalize',
  fontSize: '15px',
  color: '#FFFFFF',
  fontWeight: '700',
  lineHeight: '20px',
};
const cancelbuttonStyle = {
  fontFamily: 'Mulish',
  textTransform: 'capitalize',
  fontSize: '15px',
  color: '#EA4C59',
  lineHeight: '19px',
  fontWeight: '400',
};

const commonStyles = {
  color: '#DAE0EB',
  borderColor: '#DAE0EB',
  borderRadius: '8px',
};
const smallTextStyle = {
  fontFamily: 'Mulish',
  textTransform: 'none',
  fontSize: '13px',
  color: '#455066',
  lineHeight: '16px',
  fontWeight: '400',
};

export const LogisticsSignature = ({ user, enroutedPractice, setStep }) => {
  const classes = loginPageStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedOrders = useSelector(
    (state) => state.practicesReducer.selectedOrders
  );
  const practiceOrders = useSelector(
    (state) => state.practicesReducer.practiceOrders
  );
  const [signatureIndication, setSignatureIndication] = useState('');
  const [isSigned, setIsSigned] = useState(false);
  const checkInId = useSelector((state) => state.practicesReducer.checkInId);
  const [hasRecieved, setHasRecieved, enroutedPracticeId] = useLiveFeed();

  let signaturePad = useRef({});

  //  Signature Pad Handlers
  const handleCancel = () => {
    navigate(-1);
  };
  const OnClear = () => {
    signaturePad?.current.clear();
    setIsSigned(false);
  };

  // Utility Method for checking if all orders against practice is selected or not
  const verifyAllChecked = () => {
    const collectedEOrders = practiceOrders.filter((element) =>
      selectedOrders?.some((order) => element.id === order.order_id)
    );
    return practiceOrders.length === collectedEOrders.length;
  };

  // Utility Function for separation of e and manual orders
  const filter_orders = () => {
    const eOrders = [];
    const manualOrders = [];
    const newManualOrders = [];
    selectedOrders.forEach((element) => {
      element.type === 'manual'
        ? element.order_id === ''
          ? newManualOrders.push(element.samples)
          : manualOrders.push({
              id: element.order_id,
              samples: element.samples,
            })
        : eOrders.push(element.order_id);
    });
    return [eOrders, manualOrders, newManualOrders];
  };

  // Handler for order collection
  const handleSignatures = () => {
    if (selectedOrders) {
      const [eOrders, manualOrders, newManualOrders] = filter_orders();
      const arrivedOrders = practiceOrders
        .filter(
          (elem) => !selectedOrders.some((item) => item.order_id === elem.id)
        )
        .map((element) => element.id);

      let payload = {
        id: enroutedPractice?.id,
        practices: {
          eorder_ids: eOrders,
          rider_id: user.id,
          new_manual_orders: newManualOrders,
          manual_orders: manualOrders,
          arrived_orders: [],
          all_collected: verifyAllChecked(),
        },
      };

      // if rider is not Malaysian, we will store signature and check in id
      if (!isMalaysian(user?.country)) {
        const signatureObject = signaturePad.current
          .getTrimmedCanvas()
          .toDataURL('image/png');
        payload = {
          ...payload,
          practices: {
            ...payload.practices,
            arrived_orders: arrivedOrders,
            check_in: checkInId,
            name: signatureIndication,
            image: signatureObject,
          },
        };
      }

      // Dispatching request for Collecting Practice Orders
      dispatch(collectPracticeOrders(payload))
        .unwrap()
        .then(() => {
          /*
          On promise resolution, we will then then update status for rider,
          we will store signature, date & time of order collection and lastly
          fetch data for statistics on profile Screen
          */

          if (verifyAllChecked()) {
            dispatch(setUserStatus('assigned'));
          }
          if (!isMalaysian(user?.country)) {
            dispatch(setCheckInId(0));
            //dispatch(updateEnroutedPracticeOrders(newEnOrders));
          }
          dispatch(
            setOrderCollectedTime(
              moment(new Date()).format(' hh:mma, DD MMM YYYY')
            )
          );
          dispatch(fetchDeliveryOverviewData(user?.id));
          let updatedEnroutedPractice = JSON.parse(
            JSON.stringify(enroutedPractice)
          );
          // Updating Counts
          selectedOrders.forEach((order) => {
            if (order.type === 'eorder') {
              if (updatedEnroutedPractice.orders_count.eorders > 0)
                updatedEnroutedPractice.orders_count.eorders -= 1;
            } else {
              if (updatedEnroutedPractice.orders_count.manual_orders > 0)
                updatedEnroutedPractice.orders_count.manual_orders -= 1;
            }
            if (
              order?.priority === 'urgent' &&
              updatedEnroutedPractice.orders_count.urgent_orders > 0
            ) {
              updatedEnroutedPractice.orders_count.urgent_orders -= 1;
            }
          });

          dispatch(setEnroutedPractices([updatedEnroutedPractice]));
          setStep((prev) => prev + 1);
        })
        .catch((err) => {
          if (
            err?.error === 'You need to sign in or sign up before continuing.'
          ) {
            toast(
              <CustomToast
                severity="warning"
                message="Your session has been expired"
              />,
              { closeButton: false }
            );
            dispatch(destroyUser());
            navigate('/login');
          }
          toast(
            <CustomToast
              severity="warning"
              message="Error While Collecting Order"
            />,
            { closeButton: false }
          );
        });
    }
  };

  // This function handles new Order Alert
  const handleNewOrderAlert = () => {
    toast(
      <CustomToast
        severity="info"
        message={
          enroutedPracticeId === enroutedPractice?.id
            ? 'New Orders Assigned. Tap to view'
            : 'New Orders Assigned'
        }
        handleClick={() =>
          enroutedPracticeId === enroutedPractice?.id &&
          setStep((prev) => prev - 2)
        }
      />,
      {
        closeButton: false,
        autoClose: enroutedPracticeId === enroutedPractice?.id ? false : true,
      }
    );
    setHasRecieved(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {hasRecieved && handleNewOrderAlert()}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
          mb: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box
            sx={{
              fontSize: '19px',
              lineHeight: '25px',
              fontWeight: '700',
              color: '#054E8B',
              mx: '8px',
            }}
            className={classes.heading10}
          >
            Order Tally
          </Box>

          <Box style={smallTextStyle}>
            Please check if the quantities are correct.
          </Box>
        </Box>
        <Box sx={{ width: '100%' }}>
          <Table size="small" aria-label="Order Confirmation">
            <TableHead>
              <TableRow>
                <StyledTableCell>Sr. No.</StyledTableCell>
                <StyledTableCell>Order ID</StyledTableCell>
                <StyledTableCell align="center">No. of Samples</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cleanOrders(selectedOrders).map((row, index) => (
                <TableRow key={index} sx={{ backgroundColor: '#EBEFF5' }}>
                  <TableCell sx={tableCellStyle}>{row.id}.</TableCell>
                  <TableCell
                    sx={tableCellStyle}
                    style={{ paddingLeft: 0, width: '45%' }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        lineBreak: 'anywhere',
                      }}
                    >
                      {row.lab_barcode_id}
                      {row?.priority === 'urgent' && (
                        <Box>
                          <img src={AlertImage} alt="" />
                        </Box>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align="center">
                    <LogisticSignatureInput
                      total={row.samples}
                      collected={row.samples}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: '12px 0px',
            textAlign: 'center',
            gap: '12px',
            mx: '15.5px',
            width: '90%',
          }}
        >
          {!isMalaysian(user?.country) && (
            <>
              <Box
                className={classes.heading10}
                sx={{
                  mb: '4px',
                  fontWeight: '700',
                  fontSize: '19px',
                  lineHeight: '25px',
                  color: '#054E8B',
                }}
              >
                Clinic Staff Confirmation
              </Box>
              <Box
                className={classes.heading}
                sx={{
                  fontSize: '12px',
                  lineHeight: '16px',
                  color: '#2A3752',
                  mx: '13px',
                }}
              >
                I declare that the above collection is correct and acceptable by{' '}
                {enroutedPractice?.name}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    ...commonStyles,
                    border: 1,
                    borderColor: '#1B96D8',
                    mb: '12px',
                    py: '4px',
                    bgcolor: '#FFFFFF',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      position: 'relative',
                    }}
                  >
                    <Box
                      sx={{
                        width: '100%',
                        fontSize: '13px',
                        lineHeight: '12px',
                        color: '#8493AE',
                      }}
                    >
                      Sign within the Box
                    </Box>
                    <Button
                      onClick={OnClear}
                      className={classes.heading}
                      variant="text"
                      sx={{
                        background: '#FFFFFF',
                        border: '1px solid #CAD3E6',
                        minWidth: 'fit-content',
                        borderRadius: '99px',
                        m: '2.5px 7.5px 0px 0px',
                        p: '2px 4px',
                        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.24)',
                        ':hover': { bgcolor: '#ffffff' },
                        position: 'absolute',
                        top: 0,
                        right: 0,
                      }}
                      style={smallTextStyle}
                    >
                      Clear
                    </Button>
                  </Box>
                  <SignaturePad
                    canvasProps={{
                      width: 'auto',
                      height: 'auto',
                    }}
                    clearOnResize={false}
                    penColor="#054E8B"
                    ref={signaturePad}
                    onEnd={() => {
                      setIsSigned(true);
                    }}
                  />
                </Box>
                <Box
                  className={classes.heading}
                  sx={{
                    textAlign: 'left',
                    fontSize: '13px',
                    lineHeight: '16px',
                    color: '#455066',
                    mb: '4px',
                    textTransform: 'capitalize',
                  }}
                >
                  Please Indicate Your Name
                  <Typography
                    variant="span"
                    sx={{ ml: '2px', color: '#EA4C59' }}
                  >
                    <strong> *</strong>
                  </Typography>
                </Box>
                <Box sx={{ bgcolor: '#FFFFFF' }}>
                  <InputForSignatureIndication
                    value={signatureIndication}
                    setSignatureIndication={setSignatureIndication}
                  />
                </Box>
              </Box>
            </>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              onClick={handleCancel}
              variant="text"
              sx={{
                border: 1,
                borderColor: '#E5E5E5',
                maxWidth: '86px',
                width: '100%',
                borderRadius: '10px',
                py: '4px',
              }}
              style={cancelbuttonStyle}
            >
              Cancel
            </Button>
            <ThemeProvider theme={btnTheme}>
              <Button
                onClick={handleSignatures}
                disabled={
                  isMalaysian(user?.country)
                    ? false
                    : !(isSigned && signatureIndication.length)
                }
                variant="text"
                sx={{
                  maxWidth: '86px',
                  width: '100%',
                  borderRadius: '8px',
                  ':hover': { bgcolor: '#054E8B' },
                }}
                style={nextbuttonStyle}
              >
                Confirm
              </Button>
            </ThemeProvider>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
LogisticsSignature.propTypes = {
  user: PropTypes.object.isRequired,
  enroutedPractice: PropTypes.object.isRequired,
  setStep: PropTypes.func.isRequired,
};
export default LogisticsSignature;
